module.exports = __webpack_public_path__ + "img/talent_back.139e9262.jpg";